import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-send-reminder-to-all',
  templateUrl: './send-reminder-to-all.component.html',
  styleUrl: './send-reminder-to-all.component.scss'
})
export class SendReminderToAllComponent {

  constructor (
      private _activeModal$: NgbActiveModal
    ) {}
  closeModal(){
    this._activeModal$.close(null);
  }
}
